import {Sell} from '@mui/icons-material'
import {Autocomplete, Chip, ClickAwayListener, IconButton, TextField} from '@mui/material'
import {useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {assignTagCourse, deleteTagCourse} from '../../../../redux/actions/courses'
import {assignTagNovelty, deleteTagNovelty} from '../../../../redux/actions/novelties'
import {assignTagOffer, deleteTagOffer} from '../../../../redux/actions/offers'
import {assignTagResource, deleteTagResource} from '../../../../redux/actions/resources'
import {IRootState} from '../../../../redux/types'

interface ITag {
  id: number
  name: string
  countries: any
  brands: any
}

function TagInput({rowId, rowTags, rowCountries, rowBrandId = null, page}: any) {
  const dispatch = useDispatch()

  let processedRowCountriesStr: any
  if (!rowCountries) {
    processedRowCountriesStr = ''
  } else if (typeof rowCountries === 'string') {
    processedRowCountriesStr = rowCountries
  } else {
    processedRowCountriesStr = rowCountries.map((country: any) => country.id).join(',')
  }

  const {tags} = useSelector((state: IRootState) => state.tag)
  const {globalBrandId} = useSelector((state: IRootState) => state.global)

  const [pendingTags, setPendingTags] = useState<number[]>([])
  const [displayTags, setDisplayTags] = useState<number>(0)

  const handleMultiAutoCompleteChange = (tags: ITag[]) => {
    let tagIds: number[] = []
    if (tags !== null) {
      for (let i = 0; i < tags.length; i++) {
        tagIds.push(tags[i].id)
      }
    }

    setPendingTags(tagIds)
  }

  const handleClickChip = (id: number) => {
    setDisplayTags(id)
  }

  // biome-ignore lint/complexity/noExcessiveCognitiveComplexity: <explanation>
  const handleAddTags = (id: number) => {
    if (pendingTags.length > 0) {
      const payload = {id, tags: pendingTags, type: page}

      if (page === 'resources') dispatch(assignTagResource(payload))
      else if (page === 'courses') dispatch(assignTagCourse(payload))
      else if (page === 'offers') dispatch(assignTagOffer(payload))
      else if (page === 'novelties' || page === 'news') dispatch(assignTagNovelty(payload))
      else alert('Page sin action')
    }

    // Clear vars
    setDisplayTags(0)
    setPendingTags([])
  }

  const handleDeleteTag = (id: number, tagId: number) => {
    const payload = {id, tagId, type: page}

    if (page === 'resources') dispatch(deleteTagResource(payload))
    else if (page === 'courses') dispatch(deleteTagCourse(payload))
    else if (page === 'offers') dispatch(deleteTagOffer(payload))
    else if (page === 'novelties' || page === 'news') dispatch(deleteTagNovelty(payload))
    else alert('Page sin action')
  }

  const countriesCompare = (tagsCountries: number[], resourcesCountries: number[]) => {
    for (let i = 0; i < tagsCountries.length; i++) {
      for (let j = 0; j < resourcesCountries.length; j++) {
        if (tagsCountries[i] === resourcesCountries[j]) return 1
      }
    }

    return 0
  }

  const brandsCompare = (tagsBrands: string) => {
    if (globalBrandId === null) return tagsBrands.split(',').includes(rowBrandId?.toString())

    return tagsBrands.split(',').includes(globalBrandId?.toString())
  }

  return (
    <>
      {rowTags === null ? (
        <>
          {displayTags !== rowId ? (
            <IconButton
              aria-label="delete"
              key={rowId}
              id="btn-display-tags"
              aria-controls="tag-menu"
              aria-haspopup="true"
              onClick={() => {
                setDisplayTags(rowId)
              }}
            >
              <Sell/>
            </IconButton>
          ) : (
            <ClickAwayListener onClickAway={() => handleAddTags(rowId)}>
              <div>
                <Autocomplete
                  open
                  multiple
                  disableCloseOnSelect
                  disableClearable
                  size="small"
                  popupIcon={null}
                  id={`autocomplete-tags${rowId}`}
                  options={tags.filter(
                    (tag: ITag) =>
                      countriesCompare(tag.countries.split(','), processedRowCountriesStr.split(',')) && brandsCompare(tag.brands)
                  )}
                  defaultValue={
                    rowTags ? tags.filter((tag: ITag) => rowTags.split(',').includes(tag.id.toString())) : []
                  }
                  getOptionLabel={(tag: ITag) => (tag.id !== undefined ? tag.name : '')}
                  renderInput={(params: any) => <TextField {...params} />}
                  onChange={(_, newValue) => handleMultiAutoCompleteChange(newValue)}
                />
              </div>
            </ClickAwayListener>
          )}
        </>
      ) : (
        <>
          {displayTags !== rowId && tags.length > 0 ? (
            rowTags.split(',').map((tagId: number) => {
              const tag = tags.find((tag: ITag) => tag.id === Number(tagId))
              if (tag) {
                return (
                  <Chip
                    key={tag.id}
                    label={tag.name}
                    onClick={() => handleClickChip(rowId)}
                    onDelete={() => handleDeleteTag(rowId, tag.id)}
                  />
                )
              }

              return rowTags
            })
          ) : (
            <ClickAwayListener onClickAway={() => handleAddTags(rowId)}>
              <div>
                <Autocomplete
                  open
                  multiple
                  disableCloseOnSelect
                  disableClearable
                  size="small"
                  popupIcon={null}
                  id={`autocomplete-tags${rowId}`}
                  options={tags.filter((tag: ITag) =>
                    countriesCompare(tag.countries.split(','), processedRowCountriesStr.split(','))
                  )}
                  defaultValue={
                    rowTags ? tags.filter((tag: ITag) => rowTags.split(',').includes(tag.id.toString())) : []
                  }
                  getOptionLabel={(tag: ITag) => (tag.id !== undefined ? tag.name : '')}
                  renderInput={(params: any) => <TextField {...params} />}
                  onChange={(_, newValue) => handleMultiAutoCompleteChange(newValue)}
                />
              </div>
            </ClickAwayListener>
          )}
        </>
      )}
    </>
  )
}

export default TagInput
